module.exports = __webpack_public_path__ + "static/media/notification.08f21256.mp3";